import { render, staticRenderFns } from "./express-header.vue?vue&type=template&id=4239df41&scoped=true"
import script from "./express-header.vue?vue&type=script&lang=js"
export * from "./express-header.vue?vue&type=script&lang=js"
import style0 from "./express-header.vue?vue&type=style&index=0&id=4239df41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239df41",
  null
  
)

export default component.exports